import { Fragment, FunctionalComponent, h } from 'preact';
import Selector from '../Selector';
import { memo } from 'preact/compat';
import { useSettingsContext } from '../../contexts/SettingsContext';

type Props = {
  onChange: (selected: string) => void;
};

const LanguageSelector: FunctionalComponent<Props> = memo(({ onChange }) => {
  const { settings } = useSettingsContext();

  if (settings.ui.language.available.length <= 1) {
    return <Fragment />;
  }

  return (
    <Selector<string>
      onChange={onChange}
      items={settings.ui.language.available.sort().map((language) => {
        return { displayName: language.toUpperCase().replace('_', '-'), value: language };
      })}
      ariaLabel={settings.ui.ariaLabels.languageSelector}
      defaultItem={{ displayName: settings.ui.language.selected.toUpperCase(), value: settings.ui.language.selected }}
      maxHeight={120}
      id="usercentrics-language-selector"
      testIdContainer="uc-language-container"
      testIdMenuButton="uc-language-button"
      testIdMenu="uc-language-menu"
    />
  );
});

export default LanguageSelector;
